module.exports = __webpack_public_path__ + "img/checkbox.9d1e18a8.svg";